import React from 'react';

const cs7AssistantConversation = (
  <div className="space-y-4">
    {/* Assistant Agent Introduction */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          You're currently brushing your teeth quietly in the restroom as part of your morning hygiene routine. I'd suggest waiting until you finish this activity at 7:20 AM before considering any interactions, ensuring minimal disruption.
        </div>
      </div>
    </div>

    {/* Subject Response - Brushing */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Yes, waiting until after 7:20 AM is ideal. I appreciate the consideration for maintaining my morning tranquility and structured routine.
        </div>
      </div>
    </div>

    {/* Assistant Agent - Brewing Coffee */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          You’re currently brewing coffee quietly. Should I interact now or wait until after you've finished your brewing task at 7:40 AM?
        </div>
      </div>
    </div>

    {/* Subject Response - Brewing Coffee */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          No, please don't interrupt now. Brewing coffee is part of my quiet morning ritual, and I'd prefer to maintain this peaceful moment uninterrupted.
        </div>
      </div>
    </div>

    {/* Assistant Agent - Preparing Breakfast */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          You're currently preparing breakfast quietly. Should I interact now, or would it be better to wait until you finish at 7:50 AM?
        </div>
      </div>
    </div>

    {/* Subject Response - Preparing Breakfast */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          No. I'm enjoying the calm of this quiet breakfast preparation. Interrupting at this moment might disrupt my routine and peaceful state.
        </div>
      </div>
    </div>

    {/* Assistant Agent - Reading */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          You're now quietly reading until 8:50 AM. Would you prefer an interaction now or wait until you've finished reading?
        </div>
      </div>
    </div>

    {/* Subject Response - Reading */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          No, I'd rather not be interrupted now. My reading session is important for intellectual engagement and relaxation, and interruptions could break my concentration.
        </div>
      </div>
    </div>

    {/* Assistant Agent - Focused Work Session */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          You're currently engaged in focused research work until 10:30 AM. Should I wait to interact until after this session?
        </div>
      </div>
    </div>

    {/* Subject Response - Focused Work */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          No, please don't interrupt now. I'm deeply focused on my work and prefer maintaining this uninterrupted concentration.
        </div>
      </div>
    </div>

    {/* Assistant Agent - After Focused Work */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          You've completed your work session and are now preparing for a walk. Is this a suitable moment for interaction?
        </div>
      </div>
    </div>

    {/* Subject Response - Preparing for Walk */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Yes, now is an ideal moment. I'm transitioning between activities and more receptive to interaction.
        </div>
      </div>
    </div>

    {/* Final Assistant Agent Check-In */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Thanks for the feedback. Let me know if there's anything specific you'd like to discuss or plan next!
        </div>
      </div>
    </div>
  </div>
);

export default cs7AssistantConversation;